import { Component, OnInit } from '@angular/core';
import { CategoryService, AlertService, SettingsService } from "../../_services/index";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-create-subcategory',
  templateUrl: './create-subcategory.component.html',
  styleUrls: ['./create-subcategory.component.less']
})
export class CreateSubcategoryComponent implements OnInit {
  category_id = this.route.snapshot.params['id'];
  objectKeys = Object.keys;
  subcategoryData: any = {
    title: '',
    description: ''
  };
  translations: any[] = [];
  t: any[] = [];
  d: any[] = [];
  
  constructor(
    private _categoryService: CategoryService,
    private route: ActivatedRoute,
    private router: Router,
    private _alertService: AlertService,
    private _settingsService: SettingsService
  ) {
    this.getRegisteredLanguages();
  }

  ngOnInit() {}
  
  getRegisteredLanguages(): void {
    this._settingsService.getRegisteredLanguages()
      .subscribe(res => {
        for (let i = 0; i < res.languages.length; i++) {
          if (res.languages[i]['lang_code'] !== 'EN') {
            let tempObj = {
              [res.languages[i]['lang_code']]: {
                'title': '',
                'descr': ''
              }
            };
            this.translations.push(tempObj);
          }
        }
      }, err => {
        console.log(err);
      });
  }
  
  createSubcategory(EN_data, translations): void {
    this.t = [];
    this.d = [];
  
    for (let i = 0; i < translations.length; i++) {
      for (const key of Object.keys(translations[i])) {
        this.t.push({
          'language_code': key,
          'translation': translations[i][key].title
        });
        this.d.push({
          'language_code': key,
          'translation': translations[i][key].descr
        });
      }
    }
  
    this.d.push({
      'language_code': 'EN',
      'translation': (EN_data.description) ? EN_data.description : ''
    });
  
    let objToSend = {
      title_EN: EN_data.title,
      title_translations: this.t,
      description_translations: this.d,
      category_id: this.category_id
    };
  
    this._categoryService.createNewSubcategory(objToSend)
      .subscribe(res => {
        this._alertService.success('Alert.You successfully created new subcategory');
        this.router.navigate(['/']);
      }, err => {
        console.log(err);
        this._alertService.error(err.statusText);
      });
  }

}
